var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTriangle7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.8156 13.1156C6.18409 12.3855 7.14681 12.3856 7.51531 13.1156L11.2095 20.4339C11.565 21.1382 11.0973 22 10.3596 22H2.9713C2.23358 22 1.76592 21.1382 2.12144 20.4339L5.8156 13.1156Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1942 2.54751C11.5627 1.8175 12.5254 1.8175 12.8939 2.54751L16.588 9.86585C16.9435 10.5702 16.4759 11.4319 15.7382 11.4319H8.34986C7.61213 11.4319 7.14448 10.5702 7.5 9.86585L11.1942 2.54751Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4847 13.1156C16.8532 12.3855 17.8159 12.3856 18.1844 13.1156L21.8786 20.4339C22.2341 21.1382 21.7664 22 21.0287 22H13.6404C12.9027 22 12.435 21.1382 12.7905 20.4339L16.4847 13.1156Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangle7);
export default __webpack_public_path__ + "static/media/triangle-7.f03c3fa86c76883cfb00247253ae7c1a.svg";
export { ForwardRef as ReactComponent };